import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useCompanyActiveSystems } from '@/hooks/useCompanyActiveSystems';
import { DashboardEditor } from '@/components/dashboard/DashboardEditor';
import { useDashboardLayout } from '@/hooks/use-dashboard-layout';
import { registerAllWidgets } from '@/lib/widgets/widget-definitions';
import { Skeleton } from '@/components/ui/skeleton';
import { TrialBanner } from '@/components/company/TrialBanner';

export default function UserArea() {
  const { slug } = useParams<{ slug: string }>();
  const { companies, profile } = useAuth();
  
  const company = companies.find(c => c.slug === slug);
  const { data: activeSystems = [], isLoading: systemsLoading } = useCompanyActiveSystems(company?.id);
  const { layout, saveLayout, isLoading: layoutLoading } = useDashboardLayout({
    layoutType: 'user',
    companyId: company?.id
  });

  // Register all available widgets
  useEffect(() => {
    registerAllWidgets();
  }, []);

  // Get enabled system codes
  const enabledSystems = activeSystems.map(system => system.code);
  
  console.log('🏢 UserArea Debug:', {
    companySlug: slug,
    activeSystems: activeSystems.map(s => ({ id: s.id, code: s.code, name: s.name })),
    enabledSystems,
    systemsLoading,
    layoutLoading
  });

  if (systemsLoading || layoutLoading) {
    return (
      <div className="space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} className="h-32" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {company?.id && company?.slug && <TrialBanner companyId={company.id} companySlug={company.slug} />}
      
      <div className="space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            Bem-vindo, {profile?.full_name || 'Usuário'}!
          </h1>
          <p className="text-muted-foreground">
            Personalize seu dashboard escolhendo os widgets que mais importam para você na {company?.name}.
          </p>
        </div>

        <DashboardEditor
          enabledSystems={enabledSystems}
          initialLayout={layout || undefined}
          onSaveLayout={saveLayout}
        />
      </div>
    </>
  );
}